











import { Component, Prop, Vue } from "vue-property-decorator";
import FscModal from "@/components/Modal/FscModal.vue";

@Component({
  components: { FscModal },
})
export default class AboutExaminerModal extends Vue {
  public name = "AboutExaminerModal";

  @Prop({ type: String })
  public modalId!: string;
}
